// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2V_8r","buttons":"SendReceipts_buttons__2JUq8","email":"SendReceipts_email__3ETGQ","bookApptTitle":"SendReceipts_bookApptTitle__2fdrX"};